// Mock data for Moon and Back Support website
// All data here is for UI display. Backend integration follows later.

export const COMPANY = {
  name: "Moon and Back Support",
  tagline: "Support That Goes Further",
  description: "Compassionate. Reliable. Personalised.",
  mission: "Empowering independence and enhancing quality of life through tailored support services.",
  phone: "0424 497 770",
  email: "admin@moonandbacksupport.com.au",
  website: "moonandbacksupport.com.au",
  address: "Perth & Surrounding Areas",
  logo: "https://customer-assets.emergentagent.com/job_4a1e92b3-22bf-487f-966c-2e7c56d04898/artifacts/7ijo138w_IMG_0680.png",
  abn: "ABN Pending",
};

export const NAV_LINKS = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Team", path: "/team" },
  { label: "Book", path: "/book" },
  { label: "Contact", path: "/contact" },
];

export const SERVICES = [
  {
    id: "personal-home",
    icon: "Home",
    title: "Personal & Home Support",
    tagline: "Everyday care that makes a home feel lighter",
    image: "https://images.unsplash.com/photo-1581578731548-c64695cc6952?auto=format&fit=crop&w=1200&q=80",
    items: [
      { name: "Domestic cleaning", desc: "Regular or deep cleaning, laundry, ironing, tidying" },
      { name: "Meal preparation", desc: "Planning, shopping, nutritious meals" },
      { name: "Home organisation", desc: "Decluttering, light maintenance, management" },
      { name: "Pet care assistance", desc: "Feeding, walking, or vet appointment support" },
    ],
  },
  {
    id: "transport",
    icon: "Car",
    title: "Transport & Errands",
    tagline: "Go where life takes you - with a friendly hand",
    image: "https://images.unsplash.com/photo-1517842645767-c639042777db?auto=format&fit=crop&w=1200&q=80",
    items: [
      { name: "Chauffeuring & transport", desc: "To appointments, activities, or social events" },
      { name: "Shopping support", desc: "Groceries, errands, or online orders" },
      { name: "Appointment accompaniment", desc: "Medical or community appointments" },
    ],
  },
  {
    id: "social",
    icon: "Users",
    title: "Social & Community Participation",
    tagline: "Real connections. Real belonging.",
    image: "/team/social-community.jpg",
    items: [
      { name: "Companionship", desc: "Conversation, outings, genuine connection" },
      { name: "Community access", desc: "Events, classes, volunteering opportunities" },
      { name: "Skill-building activities", desc: "Developing independence and confidence" },
    ],
  },
  {
    id: "health",
    icon: "HeartPulse",
    title: "Health & Wellbeing Support",
    tagline: "A whole-person approach to feeling well",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?auto=format&fit=crop&w=1200&q=80",
    items: [
      { name: "Medication prompting", desc: "Reminders and routine medication assistance" },
      { name: "Exercise & mobility support", desc: "Walking, stretching, light activity" },
      { name: "Mental health support", desc: "Emotional reassurance, mindfulness, structured routines" },
      { name: "Therapy assistance", desc: "Physio, occupational or speech therapy plans" },
    ],
  },
  {
    id: "admin",
    icon: "ClipboardList",
    title: "Administrative & Lifestyle Support",
    tagline: "We handle the paperwork, you live the life",
    image: "https://images.unsplash.com/photo-1586282391129-76a6df230234?auto=format&fit=crop&w=1200&q=80",
    items: [
      { name: "NDIS plan management", desc: "Understanding and coordinating services" },
      { name: "Scheduling & reminders", desc: "Managing appointments and routines" },
      { name: "Technology support", desc: "Phones, tablets, communication devices" },
    ],
  },
  {
    id: "training",
    icon: "Dumbbell",
    title: "Personal Training",
    tagline: "Movement built around your body and your goals",
    image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?auto=format&fit=crop&w=1200&q=80",
    items: [
      { name: "1-on-1 or small group training", desc: "With a licensed trainer" },
      { name: "Personalised fitness programs", desc: "Tailored to your goals and abilities" },
      { name: "Strength, mobility & endurance", desc: "Balance and flexibility support" },
      { name: "Progress tracking", desc: "Encouragement, motivation, ongoing tracking" },
    ],
  },
];

export const VALUES = [
  {
    icon: "UserCircle2",
    title: "Person-Centred Approach",
    description: "We listen, understand, and tailor our support to your goals and preferences.",
  },
  {
    icon: "ShieldCheck",
    title: "Trusted & Reliable",
    description: "You can count on our friendly team to show up, follow through, and truly care.",
  },
  {
    icon: "Sparkles",
    title: "Empowering Independence",
    description: "We help you build confidence, skills, and the freedom to live life on your terms.",
  },
  {
    icon: "Heart",
    title: "Compassionate Care",
    description: "We treat every participant like family - with kindness, respect, and dignity.",
  },
];

export const TEAM = [
  {
    id: 1,
    name: "Kathryn Webster",
    role: "Support Coordinator & Qualified Personal Trainer",
    bio: "Kathryn blends her NDIS knowledge with a strong background in personal training, giving participants support that strengthens both daily living and overall wellbeing. She works alongside people to simplify their plans, build confidence, and create routines that feel achievable and empowering.",
    bioExtra: "She believes everyone deserves support that adapts to their life - not the other way around - and brings a calm, practical approach to every interaction.",
    image: "/team/kathryn.jpg",
    specialties: ["NDIS", "Personal Training", "Transport", "Home Support"],
  },
  {
    id: 2,
    name: "Michael Spencer",
    role: "Director",
    bio: "Michael is driven by one focus: helping people feel connected, valued, and part of their community. His work centres on building relationships, creating opportunities for meaningful engagement, and ensuring every participant feels supported in the spaces that matter to them.",
    bioExtra: "He brings a steady, people-first approach, always looking for ways to strengthen belonging and make community involvement feel natural and enjoyable.",
    image: "/team/michael.jpg",
    specialties: ["Community Connection", "Participant Experience", "Social Inclusion"],
  },
];

export const TESTIMONIALS = [
  {
    id: 1,
    name: "Margaret W.",
    relation: "Participant, 68",
    quote: "Moon and Back didn't just help me with cleaning - they helped me get my life back. I'm doing things I never thought I would again.",
    rating: 5,
  },
  {
    id: 2,
    name: "David & Helen R.",
    relation: "Parents of Jake, 24",
    quote: "Our son has a team that actually listens to him. The confidence he's built in six months has been extraordinary. We are so grateful.",
    rating: 5,
  },
  {
    id: 3,
    name: "Aisha K.",
    relation: "Participant, 32",
    quote: "Feels like family, not a service. From transport to training sessions, every hour with the team is lovely. I look forward to every visit.",
    rating: 5,
  },
  {
    id: 4,
    name: "Tom B.",
    relation: "Participant's brother",
    quote: "The team navigates my sister's NDIS plan so seamlessly that for the first time in years we're not stressed. Worth every moment.",
    rating: 5,
  },
];

export const STATS = [
  { value: "24/7", label: "Available When You Need Us" },
  { value: "100%", label: "Person-Centred Promise" },
];

export const FAQ = [
  {
    q: "Do I need to be NDIS-funded to access your services?",
    a: "No - we support NDIS participants, privately-funded clients, and aged care clients. Reach out and we'll help you understand your options.",
  },
  {
    q: "How quickly can support start?",
    a: "Almost immediately - most clients can begin receiving support within 1-5 days of our initial consultation.",
  },
  {
    q: "Can I choose my support worker?",
    a: "Absolutely. Matching the right worker with the right participant is central to our person-centred approach. You always have a say.",
  },
  {
    q: "What areas do you service?",
    a: "We currently service Perth and surrounding areas. Contact us with your location for a detailed coverage confirmation.",
  },
  {
    q: "Is there a minimum service commitment?",
    a: "No lock-in contracts. You can book as little as one session or build a long-term support plan - it's entirely on your terms.",
  },
];

export const TIME_SLOTS = [
  "07:00 AM", "08:00 AM", "09:00 AM", "10:00 AM", "11:00 AM", "12:00 PM",
  "01:00 PM", "02:00 PM", "03:00 PM", "04:00 PM", "05:00 PM", "06:00 PM",
  "07:00 PM", "08:00 PM",
];

// Mock portal data
export const MOCK_USER = {
  name: "Margaret Williams",
  email: "margaret@example.com",
  participantId: "MB-2024-0127",
  ndisNumber: "430 112 887",
  planBalance: "$24,580.00",
  nextReview: "April 14, 2026",
};

export const MOCK_BOOKINGS = [
  { id: "B001", service: "Personal & Home Support", worker: "Kathryn Webster", date: "Dec 14, 2025", time: "10:00 AM", status: "Upcoming" },
  { id: "B002", service: "Community Outing", worker: "Michael Spencer", date: "Dec 17, 2025", time: "02:00 PM", status: "Upcoming" },
  { id: "B003", service: "Personal Training", worker: "Kathryn Webster", date: "Dec 21, 2025", time: "09:00 AM", status: "Pending" },
  { id: "B004", service: "Transport - Medical", worker: "Kathryn Webster", date: "Dec 08, 2025", time: "11:00 AM", status: "Completed" },
  { id: "B005", service: "Social Inclusion Session", worker: "Michael Spencer", date: "Dec 02, 2025", time: "04:00 PM", status: "Completed" },
];

export const MOCK_MESSAGES = [
  { id: 1, from: "Kathryn Webster", preview: "Your plan review has been scheduled for April…", time: "2h ago", unread: true },
  { id: 2, from: "Michael Spencer", preview: "Looking forward to the community event on Wednesday!", time: "1d ago", unread: true },
  { id: 3, from: "Kathryn Webster", preview: "I've updated your Thursday session to 10am.", time: "3d ago", unread: false },
];
